const requestStartSuffix = '_REQUEST';
const requestSuccessSuffix = '_SUCCESS';
const requestFailedSuffix = '_FAILED';

interface LoadingState {
  isLoading: boolean;
  isLoaded: boolean;
}

interface LoadingStates {
  [key: string]: LoadingState;
}

interface Action {
  type: string;
  [key: string]: any;
}

function removeSuffix(input: string, suffix: string): string {
  return input.substring(0, input.length - suffix.length);
}

export default (
  previousState: LoadingStates = {},
  action: Action
): LoadingStates => {
  const { type } = action;
  if (type.endsWith(requestStartSuffix)) {
    return {
      ...previousState,
      ...{
        [removeSuffix(type, requestStartSuffix)]: {
          isLoading: true,
          isLoaded: false
        }
      }
    };
  }

  if (type.endsWith(requestSuccessSuffix)) {
    return {
      ...previousState,
      ...{
        [removeSuffix(type, requestSuccessSuffix)]: {
          isLoading: false,
          isLoaded: true
        }
      }
    };
  }

  if (type.endsWith(requestFailedSuffix)) {
    return {
      ...previousState,
      ...{
        [removeSuffix(type, requestFailedSuffix)]: {
          isLoading: false,
          isLoaded: false
        }
      }
    };
  }

  return previousState;
};
